
export default {
  name: 'SvgIcon',
  props: {
    name: { type: String, required: true },
    fill: { type: String, default: 'medium-grey' },
    title: { type: String, default: null },
  },
}
